import * as _ from 'lodash';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { MdbPopoverDirective } from 'mdb-angular-ui-kit/popover';
import { Subject } from 'rxjs';
import { PopoverService } from 'app/core/services/popover.service';
import { AuctionManageService } from '../../services/auction-manage/auction-manage.service';
import { currentAuctionItemCategoty } from '../../features/auction.selectors';

let id = 1;

@Component({
  selector: 'app-auction-items-filter-popover',
  templateUrl: './auction-items-filter-popover.component.html',
  styleUrls: ['./auction-items-filter-popover.component.scss']
})
export class AuctionItemsFilterPopoverComponent implements OnInit {

  @ViewChild('popover') popover: MdbPopoverDirective = null;
  @Input() categories: any = null

  public allCategoryList: any = [];

  public isProduction = false;
  public filterBtnText = 'All Items';
  public activeItem = 0

  public takeUntilSubject: Subject<any> = new Subject();
  public categories$: any = this.store.pipe(
    select(currentAuctionItemCategoty),
  )

  private _id = id++;
  get id() {
    return `AuctionsPopoverFilter_${this._id}`;
  }

  constructor(
    private popoverService: PopoverService,
    public auctionManageService:AuctionManageService,
    public store: Store,
    
  ) { }

  ngOnInit(): void {
    this.auctionManageService.filterAuctionsItems();

  }

  onPopoverShown(): void {
    this.popoverService.list[this.id] = this.popover;
  }

  onPopoverHidden(): void {
    delete this.popoverService.list[this.id];
  }

  onCategoryClick(category,activeIdx){
    this.activeItem = activeIdx
    this.filterBtnText = category
    this.auctionManageService.category = category
    this.auctionManageService.filterAuctionsItems()
  }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
